import { createContext } from 'react'
import type { Session, User, AuthError } from '@supabase/supabase-js'

export interface AuthContextValue {
  user: User | null
  session: Session | null
  loading: boolean
  signInWithGoogle: () => Promise<void>
  signInWithEmail: (email: string, password: string) => Promise<AuthError | null>
  signUpWithEmail: (email: string, password: string, firstName?: string) => Promise<{ error: AuthError | null; user: User | null; session: Session | null }>
  signOut: () => Promise<void>
}

export const AuthContext = createContext<AuthContextValue | null>(null)
